import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { DashboardLayout } from "src/components/dashboard";
import { UsersTable, UsersStaleTable } from "src/components/users";
import { Input } from "src/components/inputs";
import { Button, ButtonClass, Flex } from "src/components/ui";
import searchIcon from "src/assets/images/input/searchIcon.svg";
// RTK Query
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  useGetUsersQuery,
  useGetStaleUsersQuery,
  useLazyDumpCustomerDataQuery,
} from "src/store/services/userApi";
import { useLoading } from "src/hooks";
import { Loader } from "src/components/common";
import { toast, ToastContainer } from "react-toastify";
import { theme } from "src/styles/Theme";
import { SendNotificationModal } from "src/components/users";
import AppModal from "src/components/ui/widget/Modal/Modal";
import ModalContent from "src/components/common/ModalContent";
import { PaginationProps } from "src/components/ui/Pagination";

const UsersContainer = styled.div``;

interface Props {
  handleChange: (e: any) => void;
  handleOpen: () => void;
  handleStale: (e: any) => void;
  handleActive: (e: any) => void;
  handleExport: () => void;
  staleTableBtn: boolean;
  setLastLoginRange: React.Dispatch<React.SetStateAction<string>>;
}

export default function Users() {
  const [searchField, setSearchField] = useState("");
  const [usersList, setUsersList] = useState<UsersListTypes[]>([]);
  const [staleUsersList, setStaleUsersList] = useState<UsersListTypes[]>([]);
  const [openNotifModal, setOpenNotifModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showStaleAccount, setShowStaleAccount] = useState(false);
  const [staleTableBtn, setStaleTableBtn] = useState(true);
  const [Ppage, setPage] = useState(1);
  const [Spage, setSPage] = useState(1);
  const [lastLoginRange, setLastLoginRange] = useState('');

  const handleOpen = () => setOpenNotifModal(true);
  const handleClose = () => setOpenNotifModal(false);

  const [paginationData, setPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });

  const [sPaginationData, setsPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });

  // Data from RTK
  const { data: usersResp, isLoading: isLoadingUsers } = useGetUsersQuery({
    page: Ppage,
    limit: 10,
    search: searchField,
    lastLoginRange: lastLoginRange
  });

  const { data: staleUsersResp, isLoading: isLoadingStale } =
    useGetStaleUsersQuery({ page: Spage, limit: 10, lastLoginRange: lastLoginRange });

  useEffect(() => {
    const rows: any[] = usersResp?.payload?.data || [];
    setUsersList(rows);
    setPaginationData(usersResp?.payload?.pagination);
  }, [usersResp]);

  useEffect(() => {
    const rows: any[] = staleUsersResp?.payload?.data || [];
    setStaleUsersList(rows);
    setsPaginationData(staleUsersResp?.payload?.pagination);
  }, [staleUsersResp]);

  const handleStale = () => {
    setShowStaleAccount(true);
    setStaleTableBtn(false);
  };

  const handleActive = () => {
    setShowStaleAccount(false);
    setStaleTableBtn(true);
  };

  const filteredData = usersList.filter((data) => {
    // console.log(data?.country_name);
    return (
      data?.first_name?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.last_name?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.email?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.phone?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.country_name?.toLowerCase().includes(searchField.toLowerCase())
    );
  });

  const filteredStaleData = staleUsersList.filter((data) => {
    // console.log(data);
    return (
      data?.first_name?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.last_name?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.email?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.phone?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.country_name?.toLowerCase().includes(searchField.toLowerCase())
    );
  });

  const handleChange = (e: any) => {
    setSearchField(e.target.value);
  };

  useEffect(() => {
    document.title = "Customer's Page";
  }, []);

  //Exporting data to csv format
  const usersHeaders = ["Name", "Email", "Gender", "Phone"];
  const DATA_TO_EXPORT = usersList.map((item) => {
    return {
      first_name: `${item?.first_name} ${item.last_name}`,
      email: `${item?.email}`,
      gender: `${item?.gender}`,
      phone: `${item?.phone}`,
    };
  });

  const {
    loading: exportingData,
    startLoading: startExportingData,
    stopLoading: stopExportingData,
  } = useLoading(false);
  const [triggerDumpUsers] = useLazyDumpCustomerDataQuery();

  const dumpUserData = async () => {
    startExportingData();
    try {
      const res: any = await triggerDumpUsers().unwrap();
      toast.success(res?.message);
      setShowExportModal(false);
      const url = res?.payload?.data?.fileUrl;
      if (url) window.location.href = url;
    } catch (err: any) {
      toast.error(err?.data?.error?.message || "Export failed");
    } finally {
      stopExportingData();
    }
  };

  return (
    <DashboardLayout
      pageTitle="Customers"
      rhsHeading={
        <RhsHeading
          handleChange={handleChange}
          handleOpen={handleOpen}
          handleStale={handleStale}
          handleActive={handleActive}
          staleTableBtn={staleTableBtn}
          handleExport={() => setShowExportModal(!showExportModal)}
          setLastLoginRange={setLastLoginRange}
        />
      }
    >
      <ToastContainer />
      <UsersContainer>
        {(isLoadingUsers && !showStaleAccount) ||
        (isLoadingStale && showStaleAccount) ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "100px",
            }}
          >
            <Loader>loading...</Loader>{" "}
          </div>
        ) : showStaleAccount ? (
          <UsersStaleTable
            rows={filteredStaleData}
            Spage={Spage}
            setSPage={setSPage}
            sPaginationData={sPaginationData}
          />
        ) : filteredData.length > 0 ? (
          <UsersTable
            rows={filteredData}
            Ppage={Ppage}
            setPage={setPage}
            paginationData={paginationData}
          />
        ) : (
          <p className="table-entry-status">No Customer Found</p>
        )}
      </UsersContainer>
      <SendNotificationModal
        open={openNotifModal}
        userId={[""]}
        handleClose={handleClose}
        artisan={"customer"}
      />
      <AppModal
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
        content={
          <ModalContent
            content1="Export Customers Data"
            content2="Are you sure you want to export customers data?"
            btnAction={dumpUserData}
            linkContent={"Yes, Please"}
            onClick={() => setShowExportModal(false)}
            loading={exportingData}
          />
        }
      />
    </DashboardLayout>
  );
}

export const RhsHeading: React.FC<Props> = ({
  handleChange,
  handleOpen,
  handleExport,
  handleStale,
  handleActive,
  staleTableBtn,
  setLastLoginRange,
}) => {

  
  
    const timePeriods = [
      "All Customers",
      "Last 24 Hours",
      "Last 7 Days",
      "Last 14 Days",
      "Last 30 Days",
      "Last 90 Days",
      "Last 180 Days",
      "Last 365 Days",
    ];
  
    const [timePeriod, setTimePeriod] = useState("All Customers");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
      const dropdownRef = useRef<HTMLDivElement>(null);
  
return (
  <Flex wrap="wrap">
    <Button
      onClick={handleExport}
      classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
      style={{
        backgroundColor: theme.colors.purple,
        height: "48px",
        minWidth: "145px",
      }}
    >
      <span>Export</span>
    </Button>
    <Button
      onClick={handleOpen}
      classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
      style={{
        backgroundColor: theme.colors.purple,
        height: "48px",
        width: "max-content",
      }}
    >
      <span>Notify all customers</span>
    </Button>
    <Input
      icon={<img src={searchIcon} alt="searchIcon" />}
      type="search"
      placeholder="Search"
      handleChange={handleChange}
    />
    <Button
      onClick={handleActive}
      classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
      style={{
        backgroundColor: "#eb5656",
        height: "48px",
        width: "max-content",
      }}
      disabled={staleTableBtn}
    >
      <span>Active Users</span>
    </Button>

    <Button
      onClick={handleStale}
      classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
      style={{
        backgroundColor: "#210639",
        height: "48px",
        width: "max-content",
      }}
      disabled={!staleTableBtn}
    >
      <span>Stale Users</span>
    </Button>
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-2"
        >
          {timePeriod}
          <KeyboardArrowDownIcon fontSize="small" />
        </button>
        {isDropdownOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-10">
            {timePeriods.map((period) => (
              <button
                key={period}
                onClick={() => {
                  setTimePeriod(period);
                  setIsDropdownOpen(false);
                  if (period == 'Last 24 Hours'){
                    setLastLoginRange("24h")
                  }
                  else if (period == 'Last 7 Days'){
                    setLastLoginRange("7d")
                  }
                  else if (period == 'All Customers'){
                    setLastLoginRange("")
                  }
                  else if (period == 'Last 14 Days'){
                    setLastLoginRange("14d")
                  }
                  else if (period == 'Last 30 Days'){
                    setLastLoginRange("30d")
                  }
                  else if (period == 'Last 90 Days'){
                    setLastLoginRange("90d")
                  }
                  else if (period == 'Last 180 Days'){
                    setLastLoginRange("90d")
                  }
                  else if (period == 'Last 365 Days'){
                    setLastLoginRange("1y")
                  }

                  
                }}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg ${
                  timePeriod === period
                    ? "bg-purple-50 text-purple-600"
                    : "text-gray-700"
                }`}
              >
                {period}
              </button>
            ))}
          </div>
        )}
      </div>
  </Flex>
);
}
